import Update from "Components/GMS/Pdw/upload/Update";
import React from "react";
import Dialog from "Components/DesignSystem/Dialog/Dialog";

/**
 * "Upload XLS - Update" — used from BOTH the Products list
 * (`ProductDeltaHeader.tsx`) and the Rules CBM matrix
 * (`Components/GMS/Rules/Components/CBMCategorySelector.js`, which passes
 * `type="CBM"`). On DS `Dialog` since § 126.
 *
 * The CBM path is the one to be careful with: its commit sets
 * `RulesContext.allowNavigationRef` before navigating, so `RuleHeader`'s
 * unsaved-changes blocker does not intercept (`okf/rules/e2e.md` § 7). Nothing here
 * touches that — every prop is forwarded exactly as before.
 */
const UpdatePDW = (props) => {
  return (
    <Dialog
      isOpen={!!props.showUpdatePopup}
      onClose={props.modalUpdateClose}
      closeOnOutsideClick
      title={props?.type === "CBM" ? "Upload XLS" : "Upload XLS - Update"}
      data-testid="pdw-products-update-dialog"
    >
      <Update
        modalUpdateClose={props.modalUpdateClose}
        load_Products_By_Category={props.fetchData}
        fromProduct={true}
        ruleId={props.ruleId}
        type={props.type}
        display={props.display}
        compatibilityLevel={props.compatibilityLevel}
        fetchData={props.fetchData}
      />
    </Dialog>
  );
};

export default UpdatePDW;
